import { Component, Input } from '@angular/core';
import { KngActivityIndicatorService } from '@layout/kingswell/services/kngActivityIndicator.service';
import { BroadcasterService } from '@core/broadcaster/broadcaster.service';

@Component({
  selector: 'kng-inline-activity-indicator',
  templateUrl: './kng-inline-activity-indicator.component.html'
})
export class KngInlineActivityIndicatorComponent {

  public open: boolean = true;

  constructor(private broadcaster: BroadcasterService) {
    this.broadcaster.on('kng-activity-indicator.open').subscribe(data => {
      this.show();
    });
    this.broadcaster.on('kng-activity-indicator.close').subscribe(data => {
      this.close();
    });
  }

  close() {
    this.open = false;
  }

  show() {
    this.open = true;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-activity-indicator/kng-inline-activity-indicator.component.ts